import * as React from "react";

import SvgIcon from "@material-ui/core/SvgIcon";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

export const CheckCircleOutlineIcon = (props: SvgIconProps) => {
    const {
        viewBox = "0 0 24 25",
        ...rest
    } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest} >
            <path d="M16.59 8.08L10 14.67L6.41 11.09L5 12.5L10 17.5L18 9.5L16.59 8.08ZM12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5ZM12 20.5C7.58 20.5 4 16.92 4 12.5C4 8.08 7.58 4.5 12 4.5C16.42 4.5 20 8.08 20 12.5C20 16.92 16.42 20.5 12 20.5Z" fill="#21006E"/>
        </SvgIcon>
    );
};
